<template>
  <ValidationObserver v-slot="{handleSubmit, invalid, reset, errors}" ref="observer">
    <div class="collection-appointments page page-with-table p-2">
      <div class="card content-wrapper p-2">
        <div class="card-header d-flex align-items-center pt-0">
          <h5 class="d-inline-block mb-0">
            {{ $t('Collection Appointments') }}
          </h5>
          <span>
            <b-tooltip :target="`hint-question-mark`" :title="$t('This section displays the primary locations associated with the lots in this sale. The list is generated automatically based on the locations assigned to each lot. If a lot is assigned to a sub-location, its primary location will be displayed. If a lot is already assigned to a primary location, it will appear directly.')"/>
            <font-awesome-icon id="hint-question-mark" icon="question-circle" class="icon ml-2"/>
          </span>
          <b-button v-permission="'change_auction'" class="ml-auto" variant="primary" @click="onSaveClick"
            :disabled="loading || appointments.length === 0">
            <font-awesome-icon icon="upload" style="font-size: .9em"></font-awesome-icon>
            {{ $t('Save') }}
          </b-button>
        </div>
        <div class="card-body overflow-auto" style="max-height: 100%">
          <table class="table table-sm mb-0 collection-appointments-table">
            <tr v-for="appointment in appointments" :key="appointment.uuid">
              <td>{{ appointment.name }}</td>
              <td><input-widget type="textarea" :rows="1" :model="appointment" attribute="text" :label="false"/></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import SalesService from "@/modules/sales/SalesService";
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import CollectionAppointmentModel from "./CollectionAppointment.model";

  const {mapState} = createNamespacedHelpers('sales');

  export default {
    name: "CollectionAppointments",
    components: {InputWidget},
    computed: {
      ...mapState({
        sale: state => state.view.currentSale,
      }),
    },
    data() {
      return {
        loading: false,
        appointments: []
      }
    },
    methods: {
      async onSaveClick() {
        this.loading = true;
        this.appointments.forEach(a => a.setErrors('text', []));
        let data = {};
        for (let appointment of this.appointments) {
          if (appointment.text !== null && appointment.text !== '') {
            data[appointment.uuid] = appointment.text;
          }
        }
        let response = await SalesService.saveCollectionAppointments(this.sale.uuid, data);
        this.loading = false;
        if (response.success) {
          this.$toast('success', this.$i18n.t('Collection appointment details saved'));
        } else {
          if (response.body && response.body.invalid_loc_ids) {
            let errorMsg = this.$i18n.t('Collection appointment details cannot exceed 255 characters. Please shorten the text.');
            this.appointments.filter(a => response.body.invalid_loc_ids.includes(a.uuid))
              .forEach(a => {
                a.setErrors('text', [errorMsg]);
              });
            this.$toast('danger', errorMsg);
          } else {
            this.$toast('danger', this.$i18n.t('Error while saving collection appointment details'));
          }
        }
      }
    },
    async beforeMount() {
      let response = await SalesService.getCollectionAppointments(this.sale.uuid);
      if (response.success) {
        for (let appointment of response.body) {
          this.appointments.push(new CollectionAppointmentModel(appointment));
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "./../../scss/variables";

  .collection-appointments-table tr:first-child td {
    border-top: 0;
  }
</style>
